import React, { useEffect } from 'react';
import { Card, Container, Column, Media, Title, Tag, Content } from "rbx";
import { Redirect } from "react-router-dom";
import moment from 'moment';
import { cpfOrCnpjMask, celPhoneMask } from '../../../commons/masks';

const styleHr = {
  backgroundColor: 'transparent', 
  borderColor: 'rgb(221, 221, 221)', 
  borderStyle: 'dashed', 
  borderWidth: '1px 0px 0px', 
  marginBottom: '10px',
  marginTop: '0px'
};

const PdvDetail = () => {
  let pdv = JSON.parse(sessionStorage.getItem('pdv'));

  useEffect(()=>{
    loadDataUserPdv();
  }, [sessionStorage.getItem('pdv')]);

  if (!pdv) 
    return <Redirect to={{pathname: "/dashbord"}} />;

  const loadDataUserPdv = async () => {
    pdv = await JSON.parse(sessionStorage.getItem('pdv'));
  }

  const address = pdv.address;

  return (
    <Card>
      {
        (pdv) &&
          <>
            <Card.Header>
              <Card.Header.Title>
                <Container>
                  <Column.Group breakpoint="mobile">
                    <Column size={5}>
                      Ficha Técnica
                    </Column>
                    <Column>
                      <Tag.Group gapless style={{justifyContent:"right"}}>
                        <Tag color="dark">Cód: {pdv.pdvCode}</Tag>
                        { (pdv.isPendingActivation) ? <Tag color="danger">Inativo</Tag> : <Tag color="success">Ativo</Tag> }
                        { (pdv.isPartner) ? <Tag color="link">Parceiro</Tag> : '' }
                      </Tag.Group>
                    </Column>
                  </Column.Group>
                </Container>
              </Card.Header.Title>
            </Card.Header>
            <Card.Content>
              <Media>
                <Media.Item>
                  <Title size={5}>{pdv.name}</Title>
                  {/*(pdv.isReleased) ? '' : <strong><Tag color="danger">Aguardando primeiro acesso</Tag></strong>*/}
                </Media.Item>
              </Media>
              <Content>
                <p>CPF/CNPJ: {cpfOrCnpjMask(pdv.cpf_cnpj)}</p>
                <p>Fone: {celPhoneMask(pdv.phone)}</p>
                <p>Email: {pdv.email}</p>
                <p>Cliente desde: {moment(pdv.createdAt).format('DD/MM/YYYY')}</p>
                <hr style={styleHr} />
                <p>CADs: {pdv.cads}</p>
                <p>CADs Ativados: {pdv.activatedCads}</p>
                <p>Total CADs Pagos: {pdv.totalPaidCads}</p>
                <hr style={styleHr} />
                <p>Desconto: {pdv.discount*100}%</p>
                <hr style={styleHr} />
                {address ? `${address.street}, ${address.number} - ${address.district}` : ''}<br />
                {address ? `CEP: ${address.zipCode} - ${address.city}` : ''}
              </Content>
            </Card.Content>
          </>
      }
    </Card>
  )

}

export default PdvDetail;
